import * as types from './types';

import { execApi } from '../api/apiActions';
import NotificationsApi from '../../apis/notifications';

export const fetchFirstBlockNotifications = () => {
  return dispatch => {
    dispatch(execApi({
      type: types.FETCH_FIRST_BLOCK_NOTIFICATIONS,
      api: NotificationsApi.getFirstBlockNotifications,
      successCallback: response => {
        dispatch({
          type: types.FETCH_FIRST_BLOCK_NOTIFICATIONS,
          payload: response.block,
        });
      },
      useErrorDialog: true,
      })
    );
  };
};

export const fetchSecondBlockNotifications = () => {
  return dispatch => {
    dispatch(execApi({
        type: types.FETCH_SECOND_BLOCK_NOTIFICATIONS,
        api: NotificationsApi.getSecondBlockNotifications,
        successCallback: response => {
          dispatch({
            type: types.FETCH_SECOND_BLOCK_NOTIFICATIONS,
            payload: response.block,
          })
        },
        useErrorDialog: true,
      })
    );
  };
};


// WEBPACK FOOTER //
// ./src/actions/notifications/notificationActions.js